import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./plugins/store";
import "./plugins/vuetify";
import "./plugins/base";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export { router, store };



// WEBPACK FOOTER //
// ./src/main.js